import type { TaxonomicGroup } from "../taxonomicGroup";

export const GENDER_OPTIONS = [
  { value: "male", label: "Macho" },
  { value: "female", label: "Fêmea" },
];

export const MARKING_TYPE_OPTIONS = [
  { value: "none", label: "Nenhum" },
  { value: "collar", label: "Rastreador" },
  { value: "chip", label: "Microchip" },
  { value: "anil", label: "Anilha" },
  { value: "ear_tag", label: "Brinco" },
];

export const SPECIES_OPTIONS = [
  { value: "species1", label: "Espécie 1" },
  { value: "species2", label: "Espécie 2" },
];

export const SITUATION_OPTIONS = [
  { value: "in_captivity", label: "Em Cativeiro" },
  { value: "loose", label: "Solto" },
  { value: "death", label: "Óbito" },
];

export const GENDER_VALUES = GENDER_OPTIONS.map((option) => option.value) as [
  string,
  ...string[],
];
export const MARKING_TYPE_VALUES = MARKING_TYPE_OPTIONS.map(
  (option) => option.value,
) as [string, ...string[]];
export const SPECIES_VALUES = SPECIES_OPTIONS.map((option) => option.value);
export const SITUATION_VALUES = SITUATION_OPTIONS.map(
  (option) => option.value,
) as [string, ...string[]];

export type Gender = (typeof GENDER_OPTIONS)[number]["value"];
export type MarkingType = string;
export type Species = (typeof SPECIES_OPTIONS)[number]["value"];
export type Situation = (typeof SITUATION_OPTIONS)[number]["value"];

export interface Individual {
  id: string;
  clinicalRecord: string;
  commonName: string;
  ufuName: string;
  situation: Situation;
  gender: Gender;
  markingType: MarkingType;
  marking: string;
  taxonomicGroup: TaxonomicGroup;
  hasGPS: boolean;
  lastLocationLatitude: number;
  lastLocationLongitude: number;
  lastReleaseDate?: string | null;
  lastLocationDate: string;
  lastEntranceDate: string;
  lastCoordinates?: string | null;
  observations?: string | null;
  updatedAt: string;
  createdAt: string;
}

export const IndividualsColumns: Array<{
  id: keyof Individual | keyof TaxonomicGroup;
  label: string;
}> = [
  {
    id: "ufuName",
    label: "Nome UFU",
  },
  {
    id: "species",
    label: "Espécie",
  },
  {
    id: "situation",
    label: "Situação",
  },
  {
    id: "lastEntranceDate",
    label: "Data da Última Entrada",
  },
  {
    id: "lastReleaseDate",
    label: "Data da Última Soltura",
  },
  {
    id: "lastCoordinates",
    label: "Últimas Coordenadas",
  },
];
